exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2mShw {\n  height: 40px;\n}\n._3EAQF {\n  height: 40px;\n  line-height: 40px;\n  border-bottom: 1px solid #e5e5e5;\n  cursor: text;\n}\n", ""]);

// Exports
exports.locals = {
	"field": "_2mShw",
	"clickable": "_3EAQF"
};